export default [
  {
    path: "/",
    name: "accountLogin",
    meta: {
      title: "账号登录"
    },
    component: () => import("./account.vue")
  },
  {
    path: "/account",
    name: "account",
    meta: {
      title: "账号登录"
    },
    component: () => import("./account.vue")
  },
  {
    path: "/account/findPwd",
    name: "findPwd",
    meta: {
      title: "找回密码"
    },
    component: () => import("./findPwd.vue")
  },
  {
    path: "/account/certification",
    name: "certification",
    meta: {
      title: "实名认证",
      requireAuth: true
    },
    component: () => import("./certification.vue")
  },
  {
    path: "/account/register/:type",
    name: "register",
    meta: {
      title: "注册账号"
    },
    component: () => import("./register.vue")
  }
];
